import React, { Dispatch } from 'react';
import Translator from '../../core/i18n';
import { IFileListPageProps, IFileListPageState } from '../../models/pages/addedActivityFiles';
import { Log } from 'ng2-logger';
import { IAppState, IAction } from '../../models/action/core';
import { connect } from 'react-redux';
import { Common } from '../../core/common';
import { Redirect } from 'react-router-dom';
import CustomIframe from '../../components/iframe/iframe';
import * as IFrameActions from '../../store/actions/iFrameSource';

const _logger = Log.create('content.tsx');
const T = Translator.create();
const _common = new Common();

export class UserPage extends React.Component<any, any> {
    public state: any = {
        goToHomePage: false,
    };

    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        let model = {
            ReturnUrl: '/User'
        }
        this.props.dispatch(IFrameActions.getIFrameSource(model));
    }

    public render() {
        if (this.state.goToHomePage) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/u/Home/Cockpit/'} />
        }

        return (
            <div className="student-course activities-dashboard" style={{ padding: '10px 50px' }}>
                <div style={{ paddingTop: 0, paddingBottom: 10 }} className="row student-course-header question-filter">
                    <div className="col-md-6">
                        <div className="d-flex justify-content-between">
                            <div>
                                <h2 style={{ color: '#323231', fontSize: '20px' }}>{T.t('r_gen_users')}</h2>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 text-md-right">
                        <a onClick={() => this.setState({ goToHomePage: true })} style={{ fontSize: "12px" }}>
                            {T.t('r_gen_admin_panel_back')}
                            <i className="material-icons ml-2 align-middle" style={{ fontSize: "17px" }}>arrow_forward</i>
                        </a>
                    </div>
                </div>
                <div className="row student-course-header question-filter" style={{ alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                    <CustomIframe
                        id='preview'
                        name='previewUsers'
                        width={'96vw'}
                        height={'84vh'}
                        src={this.props.iFrameSource}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: any) => {
    if (!state) {
        return ownProps;
    }
    const newProps: any = Object.assign({}, ownProps, {
        userPreferences: state.profile.userPreferences.preferences,
        activityFilesStatisticsByTerm: state.storageManagement.activityFilesStatisticsByTerm,
        iFrameSource: state.iFrame.iFrameSource
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.storageManagement.activityFilesStatisticsByTerm === prev.storageManagement.activityFilesStatisticsByTerm &&
        next.iFrame.iFrameSource === prev.iFrame.iFrameSource;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CUserPage = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(UserPage);

export default CUserPage;
